import React from "react";

type OptionButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    /** Highlights the option currently in force. Omit entirely for act-now buttons (no state). */
    selected?: boolean;
};

/**
 * One choice in a short row of alternatives — lane widths, thresholds, clip lengths.
 *
 * Sized for a gloved thumb (44px) and stretched with flex-1 so a row of these always fills the
 * sheet edge to edge, whether there are two options or four.
 */
export const OptionButton: React.FC<OptionButtonProps> = ({ selected, className = "", children, ...rest }) => (
    <button
        type="button"
        className={`min-h-11 flex-1 rounded-xl border text-[13px] font-semibold disabled:opacity-50 ${
            selected
                ? "border-[var(--accent)] bg-[color-mix(in_srgb,var(--accent)_14%,transparent)] text-[var(--accent)]"
                : "border-[var(--line-2)] bg-[var(--surface-2)]"
        } ${className}`}
        {...rest}
    >
        {children}
    </button>
);
